// カートの内容を空にする関数
function emptyCart() {
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(response => {
    return response.json();
  }).then(data => {
    console.log('カートが空になりました。', data);
  }).catch(error => {
    console.error('カートの空にする処理でエラーが発生しました。', error);
  });
}

// ページが読み込まれたときにカートの内容を空にする
document.addEventListener('DOMContentLoaded', emptyCart);

// ブラウザの戻るボタンでページに戻った際にカートの内容を空にする
window.addEventListener('pageshow', function(event) {
  emptyCart();
});
